import { FC, useState } from 'react';
import { Button, Spin } from 'antd';

import {
	downloadAssigmentAgreement,
	downloadInvestmentAgreement,
} from 'features/myInvestments/actions';

import { language } from 'utils';

import { useAppDispatch } from 'hooks';

import { ReactComponent as PDFIcon } from 'assets/icons/pdf-icon.svg';

import s from './index.module.scss';

interface InvestmentAgreementDownloadProps {
	id: number;
	label: string;
	type?: 'buyer' | 'seller';
}

const LANG = language;

export const InvestmentAgreementDownload: FC<InvestmentAgreementDownloadProps> = ({
	id,
	label,
	type,
}) => {
	const dispatch = useAppDispatch();

	const [isLoading, setIsLoading] = useState(false);

	const onDownload = async () => {
		setIsLoading(true);
		try {
			if (type) {
				await dispatch(
					downloadAssigmentAgreement({
						investmentId: id,
						type,
						lang: LANG,
						fileName: `${label}.pdf`,
					}),
				);
			} else {
				await dispatch(downloadInvestmentAgreement({ id, lang: LANG }));
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div>
			<Button
				type="link"
				className={s.documentButton}
				onClick={onDownload}
				aria-label="download"
				disabled={isLoading}
			>
				{isLoading ? <Spin className={s.spin} size="small" /> : <PDFIcon />}
				<span className={s.label}>{label}</span>
			</Button>
		</div>
	);
};
